import React, { useEffect, useState } from "react";
import SignupFormInvitationSharedModel from "../../components/SignUpFormInvitationSharedModel";
import apiService from "../../services/ApiService";

const SignUpSharedModel = ({ register_succeeds, forbidden_page }) => {
  const [email, setEmail] = useState('');
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    apiService.checkValidInvitationSharedModel(sp.get('access_token'), sp.get('token_type')).then(async (response) => {
      if (response) {
        if (!response.ok) {
          forbidden_page();
          sp.delete('access_token');
          sp.delete('token_type');
          sp.delete('context');
          window.location.search = sp.toString();
        } else {
          const elem = await response.json();
          setEmail(elem.email);
          setValidating(false);
        }
      }
    });
  }, []);

  if (validating) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <div className="flex flex-col items-center gap-5 animate-fade-in">
          <img
            width="180"
            height="56"
            src="/logo-text-black.png"
            alt="Peerception"
          />
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-400">Verifying your invitation...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 animate-fade-in">
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden">
          {/* Header */}
          <div className="px-8 pt-10 pb-6 text-center">
            <img
              width="220"
              height="68"
              src="/logo-text-black.png"
              alt="Peerception"
              className="mx-auto mb-6"
            />
            <div className="size-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <span className="material-symbols-outlined text-[28px] text-primary">share</span>
            </div>
            <h1 className="text-xl font-bold text-slate-900">Access shared model</h1>
            <p className="text-sm text-slate-500 mt-1">Enter your details below to accept the invitation</p>
          </div>

          {/* Body */}
          <div className="px-8 pb-8">
            <SignupFormInvitationSharedModel register_succeeds={register_succeeds} email={email} />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-[11px] text-slate-400">
            By registering, I agree to{" "}
            <a href="https://app.peerception.io/documents/CG.pdf" className="underline text-slate-500 hover:text-slate-700 transition-colors">
              General Terms of Use
            </a>{" "}
            &{" "}
            <a href="https://app.peerception.io/documents/Politique_de_Confidentialite.pdf" className="underline text-slate-500 hover:text-slate-700 transition-colors">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpSharedModel;
